import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from '../../core/auth';
import {ProfileDetailsPage} from './pages/profile-details/profile-details.page';
import {ProfileService} from '../../core/services';


const routes: Routes = [
  {
    path: 'profile',
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: '',
        component: ProfileDetailsPage,
        canActivate: [AuthGuardService],
        data: {title: 'User Profile'}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [ProfileService]
})
export class ProfileRoutingModule {
}
